
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/403",
      function () {
        return require("private-next-pages/403.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/403"])
      });
    }
  